import html from "../Images/html.png";
import legant from "../Images/3legant.png";
import LinksFinder from "../Images/LinksFinder.png";
import myportfolioimg from "../Images/saksham portfolio.png";
import Netflix from "../Images/netflix-clone.png";
import sketchBook from "../Images/Sketch Book.png";
import SecretSend from "../Images/seceret send.png";

const Projectdata = [
  {
    image: SecretSend,
    project_name: "Secret Send",
    Duration: " 05/2024 - 10/2024",
    Description:
      "Developed a secure messaging platform using Next.js, NextAuth, and Resend Email, increasing secure registrations by 30%. Optimized MongoDB for real-time messages, improving load times by 40%. Integrated Gemini AI API for adaptive message suggestions, boosting user engagement.",
    technologies: [
      "https://cdn.dribbble.com/userupload/9602981/file/original-e6f9ef9e2c570d0d612b1775155a4d63.png",
      "https://cdn-icons-png.flaticon.com/512/919/919825.png",
      "https://avatars.githubusercontent.com/u/67109815?s=200&v=4",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTXgAuAwfMMDkwZScsLkBAeZ4GjyfB7GtIzcA&usqp=CAU",
      "https://img.icons8.com/color/96/000000/mongodb.png",
    ],
    demo: "https://mystery-messages-sqbz.vercel.app/",
    source: "https://github.com/Saksham2k3s/SecretSend",
  },
  {
    image: legant,
    project_name: "Ecommerce Website",
    Duration: "07/2024 - 08/2024",
    Description:
      "3legant. is a full-stack e-commerce app built with React, Redux, Node.js, Express, MongoDB, and Tailwind CSS. It features product management, shopping cart functionality, user authentication, and optimized search using Zod validation.",
    technologies: [
      "https://img.icons8.com/color/96/000000/react-native.png",
      "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/redux-icon.png",
      "https://cdn-icons-png.flaticon.com/512/919/919825.png",
      "https://avatars.githubusercontent.com/u/67109815?s=200&v=4",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTXgAuAwfMMDkwZScsLkBAeZ4GjyfB7GtIzcA&usqp=CAU",
      "https://img.icons8.com/color/96/000000/mongodb.png",
    ],
    demo: "https://3legant-frontend.vercel.app/",
    source: "https://github.com/Saksham2k3s/3legant.",
  },
  {
    image: Netflix,
    project_name: "Netflix Clone",
    Duration: "05/2024 - 05/2024",
    Description:
      "I built a Netflix clone using React.js with movie data fetched from the TMDb API. It supports multiple languages with i18next and features a dynamic movie carousel, along with state management using Redux.",
    technologies: [
      "https://img.icons8.com/color/96/000000/react-native.png",
      "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/redux-icon.png",
      "https://cdn-icons-png.flaticon.com/512/919/919825.png",
      "https://avatars.githubusercontent.com/u/67109815?s=200&v=4",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTXgAuAwfMMDkwZScsLkBAeZ4GjyfB7GtIzcA&usqp=CAU",
      "https://img.icons8.com/color/96/000000/mongodb.png",
    ],
    demo: "https://legendary-pika-a5047a.netlify.app/",
    source: "https://github.com/Saksham2k3s/Netflix-Client",
  },
  {
    image: sketchBook,
    project_name: "Sketch Book",
    Duration: "03/2024 - 03/2024",
    Description:
      "Sketchbook: A digital canvas for your creativity. Pick colors, erase, undo/redo, and download your creations hassle-free. Express yourself effortlessly!",
    technologies: [
      "https://cdn-icons-png.flaticon.com/512/732/732190.png",
      "https://cdn-icons-png.flaticon.com/512/732/732212.png",
      "https://img.icons8.com/color/96/000000/react-native.png",
      "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/redux-icon.png",
      "https://www.qualtrics.com/m/assets/marketplace/wp-content/uploads/2022/03/canvas.png",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Socket-io.svg/1024px-Socket-io.svg.png",
    ],
    demo: "https://sketchbook-orcin.vercel.app/",
    source: "https://github.com/Saksham2k3s/SketchBook-Client",
  },
  {
    image: LinksFinder,
    project_name: "LinksFinder",
    Duration: "11/2023 - 11/2023",
    Description:
      "An innovative platform designed to simplify the process of finding high-quality learning resources. LinksFinder aims to provide a centralized hub where you can effortlessly discover the most valuable and up-to-date video tutorials across the digital landscape.",
    technologies: [
      "https://cdn-icons-png.flaticon.com/512/732/732190.png",
      "https://cdn-icons-png.flaticon.com/512/732/732212.png",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      "https://cdn.worldvectorlogo.com/logos/bootstrap-5-1.svg",
      "https://cdn-icons-png.flaticon.com/512/919/919825.png",
      "https://img.icons8.com/color/96/000000/react-native.png",
      html,
    ],
    demo: "https://saksham2k3s.github.io/LinksFinder/",
    source: "https://github.com/Saksham2k3s/LinksFinder",
  },
  {
    image: myportfolioimg,
    project_name: "My Portfolio",
    Duration: "06/2023 - 07/2023",
    Description:
      "This is my personal website where you can know more about me.",
    technologies: [
      "https://cdn-icons-png.flaticon.com/512/732/732190.png",
      "https://cdn-icons-png.flaticon.com/512/732/732212.png",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      "https://cdn.worldvectorlogo.com/logos/bootstrap-5-1.svg",
      "https://cdn-icons-png.flaticon.com/512/919/919825.png",
      "https://img.icons8.com/color/96/000000/react-native.png",
    ],
    demo: "http://sakshamportfolio2k3.netlify.app",
    source: "https://github.com/Saksham2k3s/My_Portfolio",
  },
];
export default Projectdata;
